import type { AssessmentType } from '@mend/types/assessment';

import { useQuery } from '@tanstack/react-query';

import { FormsAutocomplete } from '#components/Autocomplete/FormsAutocomplete.tsx';
import { assessments } from '#lib/react-query/queries.ts';
import { useFilterAutocomplete } from './use-filter-autocomplete.ts';

const defaultProps = {
  inputLabel: 'Form Type',
  inputSize: 'medium',
} as const;

export function AssessmentType(props: {
  defaultValue: AssessmentType['id'][];
}) {
  const query = useQuery(assessments);

  const filterAutocomplete = useFilterAutocomplete({
    searchParamKey: 'astId',
    defaultValue: props.defaultValue,
    data: query.data,
  });

  if (query.isLoading) {
    return <FormsAutocomplete {...defaultProps} value={null} disabled />;
  }

  return (
    <FormsAutocomplete
      {...defaultProps}
      {...filterAutocomplete.getAutocompleteProps()}
    />
  );
}
